var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12838",
    "data-name": "Group 12838",
    transform: "translate(907 -9006)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-907 9006)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12656",
    "data-name": "Group 12656",
    transform: "translate(-493.335 8699.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M-472.633,204.349c-.015-.3-.033-.494-.033-.687q.008-22.92.019-45.84a5.142,5.142,0,0,1,4.185-5.3,6.4,6.4,0,0,1,1.274-.081c13.675,0,27.35.021,41.024-.023a5.3,5.3,0,0,1,5.4,4.23,7.034,7.034,0,0,1,.081,1.274c0,10.2-.037,20.4.027,30.6a5.412,5.412,0,0,1-5.553,5.537c-11.805-.054-23.611-.019-35.416-.03a1.425,1.425,0,0,0-1.117.453q-4.658,4.695-9.346,9.359C-472.237,203.994-472.4,204.134-472.633,204.349Zm41.552-41.483h-31.16V168h31.16Zm0,7.8h-31.161v5.138h31.161Zm-31.178,12.986h.789q7.918,0,15.837,0c1.372,0,2.744-.055,4.116-.085q.033-2.033.065-4.065c.005-.338,0-.677,0-1.022H-462.26Z",
    transform: "translate(99 195)",
    fill: "#4c5b71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.305e739c3032a043bd353d5ff6458f4e.svg";
export { ForwardRef as ReactComponent };